export const APP_CONST = {
    ROUTE_DASHBOARD: '/dashboard',
    ROUTE_ACCOUNTS: '/accounts',
    ROUTE_LOGIN: '/login',
    ROUTE_RESET_PASSWORD: '/reset-password',
    ROUTE_FORGET_PASSWORD: '/forgot-password',
    ROUTE_ACCOUNT_DETAILS: '/accounts/home',
    ROUTE_PROJECT_DETAILS: 'account/project/scores',
    ROUTE_PROJECT_INTERACTION_SETTINGS: 'account/project/settings/interaction',
    ROUTE_LOGOUT: '/logout',
    ROUTE_ACCOUNT_CREATE: '/accounts/create',
    TITLE_HOME: 'Home',
    ROUTE_ACCOUNTS_INBOX_FEED_DETAILS:'/accounts/inbox/home/feed',
    TITLE_SCORES: 'Scores',
    TITLE_INBOX: 'Inbox',
    TITLE_OUTBOX:'Outbox',
    TITLE_ACTION: 'Action',
    TITLE_RELATIONSHIP_VIEW: 'Relationship View',
    TITLE_ENGAGEMENT: 'Engagement',
    SUBMENU_TITLE_GENERAL: 'General (account)',
    SUBMENU_TITLE_PROJECTS: 'Projects',
    SUBMENU_TITLE_SUB_ACCOUNT: 'Sub account',
    SUB_ACCOUNT_SUBMENU_TITLE_NOTIFICATIONS: 'Notifications',
    SUBMENU_TITLE_USER_ACCESS: 'User access',
    SUBMENU_TITLE_CONFIGURE_DASHBOARD: 'Configure dashboard',
    SUBMENU_TITLE_SECURITY: 'Security',
    SUBMENU_TITLE_NOTIFICATION: 'Notification',
    SUBMENU_TITLE_CONVERSATION: 'Conversation',
    SUBMENU_TITLE_CHANNELS: 'Channels',
    SUBMENU_TITLE_ORGANISATION: 'Organisation',
    SUBMENU_TITLE_REQUEST: 'Request',
    SUBMENU_TITLE_ACTION: 'Action',
    SUBMENU_TITLE_DATASETS: 'Datasets',
    SUBMENU_TITLE_TOOLS: 'Tools',
    TITLE_SETTINGS: 'Settings',
    TITLE_HUDDLE:'Huddle',
    TITLE_SENTIMENT_ANALYSIS: 'Sentiment Analysis',
    TITLE_QUICK_SIGHT: 'Quick Sight',
    ROUTES_ACCOUNTS: {
        home: "home",
        scores: "scores",
        inbox: "inbox",
        outbox:"outbox",
        engagement: "engagement",
        action: "action",
        settings: "settings",
        huddle:"huddle",
        sentimentAnalysis: "sentiment-analysis"
    },
    ROUTES_PROJECT: {
        home: "project/home",
        scores: "project/scores",
        inbox: "project/inbox",
        outbox:"poject/outbox",
        engagement: "project/engagement",
        action: "project/action",
        settings: "project/settings",
        huddle:"project/huddle",
        sentimentAnalysis: "sentiment-analysis"
    }

}
